import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const BellIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg width="24" height="24" fill="none" ref={ref} {...props}>
    <g clipPath="url(#clip0_723_185)" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5.265 10.502a6.732 6.732 0 0 1 13.465 0v0c0 3.357.703 5.308 1.322 6.376a.75.75 0 0 1-.647 1.126H4.59a.75.75 0 0 1-.647-1.126c.62-1.068 1.322-3.019 1.322-6.376Z" />
      <path d="M8.998 18.003v.75a3 3 0 1 0 6.001 0v-.75M17.193 2.25a9.845 9.845 0 0 1 3.563 3.948M3.24 6.198a9.845 9.845 0 0 1 3.564-3.947" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(-.004)" d="M0 0h24.004v24.004H0z" />
      </clipPath>
    </defs>
  </svg>);
export default BellIcon;